export class ActivityRequiresRegistrationError extends Error {
  presenterLogin: string
  activityType: string
  activityKey: string

  constructor (presenterLogin: string, activityType: string, activityKey: string) {
    super('Activity requires registration')
    this.name = 'ActivityRequiresRegistrationError'
    this.message =
    this.presenterLogin = presenterLogin
    this.activityType = activityType
    this.activityKey = activityKey
  }

  toJSON () {
    return {
      error: {
        name: this.name,
        message: this.message,
        presenterLogin: this.presenterLogin,
        activityType: this.activityType,
        activityKey: this.activityKey,
        stacktrace: this.stack
      }
    }
  }
}
